import { Moment } from "moment";
import { agent } from "@shared/services/agent";
import { DATE_FORMAT } from "@shared/utils/DateUtils";
import { SignageFloorPlan } from "@features/signage/data/signage-service";

export interface OfficeHeatMap {
  officeId: number;
  officeLabel: string;
  fromDate: string;
  toDate: string;
  // Working dates only: weekends are left out unless the company uses seven-day weeks
  dates: string[];
  floors: FloorHeatMapRow[];
}

export interface FloorHeatMapRow {
  floorId: number;
  label: string;
  capacity: number;
  hasFloorPlan: boolean;
  // People per half day. Dates nobody was in are left out.
  days: HeatMapDayCount[];
}

export interface HeatMapDayCount {
  date: string;
  am: number;
  pm: number;
}

export interface FloorHeatMap {
  floorId: number;
  label: string;
  fromDate: string;
  toDate: string;
  daysInRange: number;
  hasFloorPlan: boolean;
  plan: SignageFloorPlan;
  desks: DeskHeat[];
  areas: AreaHeat[];
  meetingRooms: MeetingRoomHeat[];
}

export interface DeskHeat {
  deskId: number;
  label: string;
  // Days booked, half days counting 0.5
  usage: number;
}

export interface AreaHeat {
  areaId: number;
  label: string;
  capacity: number;
  // Person-days, half days counting 0.5
  usage: number;
}

export interface MeetingRoomHeat {
  roomId: string;
  name: string;
  totalBookings: number;
  totalHoursBooked: number;
  utilizationPercentage: number;
}

export function getOfficeHeatMap(officeId: number, from: Moment, to: Moment): Promise<OfficeHeatMap> {
  return agent.requests.get(`/api/report/office-heat-map?officeId=${officeId}&fromDate=${from.format(DATE_FORMAT)}&toDate=${to.format(DATE_FORMAT)}`);
}

export function getFloorHeatMap(floorId: number, from: Moment, to: Moment): Promise<FloorHeatMap> {
  return agent.requests.get(`/api/report/office-heat-map/floor?floorId=${floorId}&fromDate=${from.format(DATE_FORMAT)}&toDate=${to.format(DATE_FORMAT)}`);
}
